<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
        <div class="MyResume">
            <div class="lableName" :style="{'left': left}">
                <p class="title">简历目录</p>
                <p :class="[type==i+1?'active li':'li']" @click="gotoScroll(i)" v-for="(item,i) in typeList" :key="i">{{item}}<span v-if="getShow(i+1)">待完善</span></p>
            </div>
            <div class="MyResumeBox">
                <div class="topTitle clearfix">
                    我的简历<i v-if="isShowOk">待完善</i><span @click="gotoPreview">预览简历</span>
                </div>
                <div id="view1">
                    <div class="box">
                        <div :class="[hoverBox1?'infoBox clearfix infoBoxHover':'infoBox clearfix']" @mouseenter="hoverBg(1)" @mouseleave="leaveBg(1)" v-if="!isShow1">
                            <div class="infoLeft">
                                <p class="name">{{recruitResumeBaseResponse.name}}<span v-if="getShow(1)">待完善</span></p>
                                <p class="year"><i v-if="recruitResumeBaseResponse.idType == 1">{{getBirthday(recruitResumeBaseResponse.beginWorkTime)}}年 | </i><i v-if="recruitResumeBaseResponse.education">{{getEducation(recruitResumeBaseResponse.education)}} | </i><i v-if="recruitResumeBaseResponse.birthday">{{getBirthday(recruitResumeBaseResponse.birthday)}}岁  |</i>  <i v-if="recruitResumeBaseResponse.jobStatus">{{getJobs(recruitResumeBaseResponse.jobStatus)}}  |</i>  <i v-if="recruitResumeBaseResponse.areaName">{{getCityName(recruitResumeBaseResponse.areaName)}}</i></p>
                                <p class="numberBox"><span class="phone" v-if="recruitResumeBaseResponse.mobile"><img src="https://image.manamana.net/1659691077000_wRYZpgku" alt="">{{recruitResumeBaseResponse.mobile | accountCut("phone")}}</span><span class="email" v-if="recruitResumeBaseResponse.email"><img src="https://image.manamana.net/1659691101000_aRuncQPL" alt="">{{recruitResumeBaseResponse.email | accountCut("email")}}</span><span class="wechat" v-if="recruitResumeBaseResponse.wechatLink"><img src="https://image.manamana.net/1659691111000_qSCYKHpd" alt="">{{recruitResumeBaseResponse.wechatLink}}</span></p>
                            </div>
                            <div class="infoRight">
                                <div class="imgBox">
                                    <img class="acartImg" :src="recruitResumeBaseResponse.avatar | imageUrl('',50,50)" alt="">
                                    <img class="genderImg" v-if="recruitResumeBaseResponse.gender" :src="recruitResumeBaseResponse.gender == 1 ?'https://image.manamana.net/1657164336000_qqLGIZKL':'https://image.manamana.net/1657164354000_mZFYvNei'" alt="">
                                </div>
                            </div>
                            <div class="edit" v-if="hoverBox1" @click="showEdit(1)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</div>
                        </div>
                        <div class="editInfo" v-if="isShow1">
                            <p class="infoTitle">编辑个人信息</p>
                            <div class="changeImgBox">
                                <img :src="recruitResumeBaseResponse1.avatar | imageUrl('',50,50)" alt="">
                                <i @click="reUpload">修改头像</i>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>姓名</div>
                                    <el-input  placeholder="请输入您的姓名" v-model="recruitResumeBaseResponse1.name"></el-input>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName"><i>*</i>性别</div>
                                    <div class="radioBox clearfix"><span :class="[recruitResumeBaseResponse1.gender==1?'active': '']" @click="recruitResumeBaseResponse1.gender=1">男</span><span :class="[recruitResumeBaseResponse1.gender==2?'active': '']" @click="recruitResumeBaseResponse1.gender=2">女</span></div>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>生日</div>
                                    <el-date-picker
                                        v-model="recruitResumeBaseResponse1.birthday"
                                        :picker-options="pickerOptions"
                                        style="width: 258px;"
                                        type="date"
                                        placeholder="请选择您的生日">
                                    </el-date-picker>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName"><i>*</i>所在城市</div>
                                    <el-select
                                        v-model="recruitResumeBaseResponse1.area"
                                        filterable
                                        style="width: 258px;"
                                        placeholder="请选择所在城市"
                                        >
                                        <el-option
                                            :label="language === 'zh' ? item.zh : item.en"
                                            :value="item.id"
                                            v-for="item in cityOptions"
                                            :key="item.id"
                                        ></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>身份类型</div>
                                    <div class="radioBox clearfix"><span :class="[recruitResumeBaseResponse1.idType==1?'active': '']" @click="recruitResumeBaseResponse1.idType=1">职场人士</span><span :class="[recruitResumeBaseResponse1.idType==2?'active': '']" @click="recruitResumeBaseResponse1.idType=2">学生</span></div>
                                </div>
                                <div class="rightForm" v-if="recruitResumeBaseResponse1.idType==1">
                                    <div class="infoName"><i>*</i>参加工作时间</div>
                                    <el-date-picker
                                        v-model="recruitResumeBaseResponse1.beginWorkTime"
                                        type="month"
                                        style="width: 258px;"
                                        :picker-options="pickerOptions"
                                        placeholder="请选择参加工作时间">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>求职状态</div>
                                    <el-select
                                        v-model="recruitResumeBaseResponse1.jobStatus"
                                        filterable
                                        placeholder="请选择求职状态"
                                        style="width: 258px;"
                                        >
                                        <el-option
                                            :label="item.title"
                                            :value="item.status"
                                            v-for="item in jobList"
                                            :key="item.status"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName"><i>*</i>手机号</div>
                                    <el-popover
                                        placement="top"
                                        trigger="hover">
                                        <div class="peopleChange">如需修改可直接在 <i @click="gotoManage">个人中心 - 账号与安全</i> 中修改</div>
                                        <el-input slot="reference"  placeholder="请输入您的手机号" :value="recruitResumeBaseResponse1.mobile | accountCut('phone')" disabled></el-input>
                                    </el-popover>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>邮箱号</div>
                                    <el-popover
                                        placement="top"
                                        trigger="hover">
                                        <div class="peopleChange">如需修改可直接在 <i @click="gotoManage">个人中心 - 账号与安全</i> 中修改</div>
                                        <el-input slot="reference" placeholder="请输入您的邮箱号" :value="recruitResumeBaseResponse1.email | accountCut('email')" disabled></el-input>
                                    </el-popover>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName">微信号</div>
                                    <el-input  placeholder="请输入您的微信号" v-model="recruitResumeBaseResponse1.wechatLink"></el-input>
                                </div>
                            </div>
                            <div class="butBox1">
                                <span class="save" @click="saveInfo">保存</span><span @click="isShow1=false,hoverBox1=false" class="close2">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view2">
                    <div class="box">
                        <div class="advantage" @mouseenter="hoverBg(2)" @mouseleave="leaveBg(2)" v-if="!isShow2 && recruitResumeAdvantageResponse.advantage">
                            <p class="nameTitle clearfix">个人优势<span v-if="hoverBox2" @click="showEdit(2)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</span></p>
                            <div :class="[hoverBox2?'textHtml textHtmlHover':'textHtml']">
                                <p v-html="getHtml(recruitResumeAdvantageResponse.advantage)"></p>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!isShow2 && !recruitResumeAdvantageResponse.advantage">
                            <p class="improved">个人优势<span>待完善</span></p>
                            <div class="addText" @click="showEdit(2)">
                                <span>90%的招聘者非常关注候选人的个人优势</span>立即添加
                            </div>
                        </div>
                        <div class="editAdvantage" v-if="isShow2">
                            <p class="infoTitle">编辑个人优势</p>
                            <el-input
                                type="textarea"
                                placeholder="请输入个人优势..."
                                v-model="recruitResumeAdvantageResponse1.advantage"
                                maxlength="500"
                                show-word-limit
                                style="width: 575px;height: 108px;"
                            ></el-input>
                            <div class="butBox1">
                                <span class="save" @click="saveAdvantage">保存</span><span class="close2" @click="isShow2=false,hoverBox2=false">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view3">
                    <div class="box">
                        <div class="expect" v-if="!isShow3 && recruitResumeExpectationResponses.length">
                            <p class="nameTitle clearfix">求职期望<span @click="showEdit(3)" v-if="recruitResumeExpectationResponses.length < 3"><img src="https://image.manamana.net/1659691179000_NRBoGGYI" alt="">添加</span></p>
                            <div :class="[expectHover==i+1?'expectList clearfix expectHover':'expectList clearfix']" v-for="(item,i) in recruitResumeExpectationResponses" :key="i" @mouseenter="expectHover=i+1" @mouseleave="expectHover=null">
                                <div class="expectLeft"><span><img src="https://image.manamana.net/1659691295000_OIdRmgXC" alt="">{{item.positionName}}</span><i>|</i><span><img src="https://image.manamana.net/1659691316000_rCWAXxQe" alt="">{{item.negotiable == 0 ? item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K' : '面议'}}</span><i>|</i><span><img src="https://image.manamana.net/1659691332000_siBzquGq" alt="">{{item.cityName}}</span></div>
                                <div class="expectRight" v-if="expectHover==i+1"><span @click="showEdit(3,i+1)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</span><span @click="deteleFile(2,item.id)"><img src="https://image.manamana.net/1657268061000_gpqgGfEY" alt="">删除</span></div>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!isShow3 && !recruitResumeExpectationResponses.length">
                            <p class="improved">求职期望<span>待完善</span></p>
                            <div class="addText" @click="showEdit(3)">
                                立即添加
                            </div>
                        </div>
                        <div class="editExpect"  v-if="isShow3">
                            <p class="infoTitle">编辑求职期望</p>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>期望职位</div>
                                    <el-autocomplete
                                      v-model="recruitResumeExpectationResponses1.positionName"
                                      :fetch-suggestions="querySearchAsync"
                                      placeholder="请输入期望职位"
                                      :trigger-on-focus="false"
                                      @select="handleSelect"
                                    ><template slot-scope="{item}">
                                        <div v-html="item.umName"></div>
                                      </template>
                                    </el-autocomplete>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName"><i>*</i>工作城市</div>
                                    <el-select
                                        v-model="recruitResumeExpectationResponses1.cityId"
                                        filterable
                                        style="width: 258px;"
                                        placeholder="请选择工作城市"
                                        >
                                        <el-option
                                            :label="item.cityName"
                                            :value="item.id"
                                            v-for="item in cityList"
                                            :key="item.id"
                                        ></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>期望薪资</div>
                                    <el-select v-model="recruitResumeExpectationResponses1.salaryBegin" placeholder="请选择" style="width: 112px;">
                                        <el-option
                                        v-for="item in moneyList"
                                        :key="item.value"
                                        :label="item.label"
                                        v-if="item.value!=260"
                                        :value="item.value">
                                        </el-option>
                                    </el-select><i style="margin: 0 10px;" v-if="recruitResumeExpectationResponses1.salaryBegin!==9999">至</i><el-select v-model="recruitResumeExpectationResponses1.salaryEnd" placeholder="请选择" style="width: 112px;" v-if="recruitResumeExpectationResponses1.salaryBegin!==9999" :disabled="!recruitResumeExpectationResponses1.salaryBegin">
                                        <el-option
                                        v-for="item in moneyList"
                                        :key="item.value"
                                        :label="item.label"
                                        v-if="item.value > recruitResumeExpectationResponses1.salaryBegin && item.value!=9999"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="butBox1">
                                <span class="save" @click="saveEditExpect">保存</span><span class="close2" @click="isShow3=false,expectHover=null">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view4">
                    <div class="box">
                        <div class="experience" v-if="!isShow4 && recruitResumeWorkExperienceResponses.length">
                            <p class="nameTitle clearfix">{{recruitResumeBaseResponse.idType == 1 ? '工作经历': '实习/工作经历'}}<span @click="showEdit(4)"><img src="https://image.manamana.net/1659691179000_NRBoGGYI" alt="">添加</span></p>
                            <div :class="[experienceHover==i+1?'experienceList experienceListHover':'experienceList']" v-for="(item,i) in recruitResumeWorkExperienceResponses" :key="i" @mouseenter="experienceHover=i+1" @mouseleave="experienceHover=null">
                                <div class="experienceName">
                                    <div class="timeBox clearfix"><p>{{item.companyName}}</p><span>{{item.workBeginTime | formatDate("YYYY.MM")}} - <i v-if="item.workEndTime">{{item.workEndTime | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></div>
                                    <p class="editPosition" v-if="experienceHover==i+1"><span @click="showEdit(4,i+1)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</span><span @click="deteleFile(3,item.id)"><img src="https://image.manamana.net/1657268061000_gpqgGfEY" alt="">删除</span></p>
                                    <p class="typeNameBox">{{item.positionName}}</p>
                                    <div class="experienceHtml">
                                        <p v-html="getHtml(item.workContent)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!isShow4 && !recruitResumeWorkExperienceResponses.length">
                            <p class="improved">{{recruitResumeBaseResponse.idType == 1 ? '工作经历': '实习/工作经历'}}<span v-if="recruitResumeBaseResponse.idType == 1">待完善</span></p>
                            <div class="addText" @click="showEdit(4)">
                                立即添加
                            </div>
                        </div>
                        <div class="editExperience" v-if="isShow4">
                            <p class="infoTitle">编辑工作经历<span>保存后可继续添加下一条</span></p>
                            <div class="formBox clearfix">
                                <div class="leftForm leftForm1">
                                    <div class="infoName"><i>*</i>公司名称</div>
                                    <el-input  placeholder="请输入公司名称" v-model="recruitResumeWorkExperienceResponses1.companyName"></el-input>
                                </div>
                                <div class="rightForm">
                                    <div class="infoName"><i>*</i>职位名称</div>
                                    <el-input  placeholder="请输入职位名称" v-model="recruitResumeWorkExperienceResponses1.positionName"></el-input>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm leftForm1">
                                    <div class="infoName"><i>*</i>在职时间</div>
                                    <el-date-picker
                                        v-model="recruitResumeWorkExperienceResponses1.workBeginTime"
                                        type="month"
                                        style="width: 120px;"
                                        :picker-options="{disabledDate:data=>startDatePicker(data,recruitResumeWorkExperienceResponses1.workEndTime)}"
                                        placeholder="开始">
                                    </el-date-picker><i style="margin: 0 10px;">至</i><el-date-picker
                                        v-model="recruitResumeWorkExperienceResponses1.workEndTime"
                                        type="month"
                                        style="width: 120px;"
                                        :class="[recruitResumeWorkExperienceResponses1.timeEndNow?'time-picker':'']"
                                        :picker-options="pickerWorkOptions_e1"
                                        :placeholder="recruitResumeWorkExperienceResponses1.timeEndNow?'至今':'请选择'">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="textareaBox">
                                <div class="infoName"><i>*</i>工作内容</div>
                                <el-input
                                    type="textarea"
                                    placeholder="请输入工作内容..."
                                    v-model="recruitResumeWorkExperienceResponses1.workContent"
                                    maxlength="1500"
                                    show-word-limit
                                    style="width: 575px;height: 108px;"
                                ></el-input>
                            </div>
                            <div class="butBox1">
                                <span class="save" @click="saveEditExperience">保存</span><span class="close2" @click="isShow4=false,experienceHover=null">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view5">
                    <div class="box">
                        <div class="experience" v-if="!isShow5 && recruitResumeProjectExperienceResponses.length">
                            <p class="nameTitle clearfix">项目经历<span @click="showEdit(5)"><img src="https://image.manamana.net/1659691179000_NRBoGGYI" alt="">添加</span></p>
                            <div :class="[projectHover==i+1?'experienceList experienceListHover':'experienceList']" v-for="(item,i) in recruitResumeProjectExperienceResponses" :key="i" @mouseenter="projectHover=i+1" @mouseleave="projectHover=null">
                                <div class="experienceName">
                                    <div class="timeBox clearfix"><p>{{item.projectName}}</p><span>{{item.projectCycleBegin | formatDate("YYYY.MM")}} - <i v-if="item.projectCycleEnd">{{item.projectCycleEnd | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></div>
                                    <p class="editPosition" v-if="projectHover==i+1"><span @click="showEdit(5,i+1)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</span><span @click="deteleFile(4,item.id)"><img src="https://image.manamana.net/1657268061000_gpqgGfEY" alt="">删除</span></p>
                                    <p class="typeNameBox">{{item.projectRole}}</p>
                                    <div class="experienceHtml">
                                        <p v-html="getHtml(item.projectDes)"></p>
                                    </div>
                                    <div class="experienceHtml">
                                        <p v-html="getHtml(item.projectPerformance)"></p>
                                    </div>
                                    <p class="link" v-if="item.projectLink">项目链接：<a target="_blank" :href="item.projectLink">{{item.projectLink}}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!isShow5 && !recruitResumeProjectExperienceResponses.length">
                            <p class="improved">项目经历</p>
                            <div class="addText" @click="showEdit(5)">
                                立即添加
                            </div>
                        </div>
                        <div class="editExperience" v-if="isShow5">
                            <p class="infoTitle">编辑项目经历<span>保存后可继续添加下一条</span></p>
                            <div class="link">
                                <p class="linkTitle"><i>*</i>项目名称</p>
                                <el-input placeholder="请输入项目名称" v-model="recruitResumeProjectExperienceResponses1.projectName"></el-input>
                            </div>
                            <div class="link">
                                <p class="linkTitle">项目链接（选填）</p>
                                <el-input placeholder="请输入项目链接" v-model="recruitResumeProjectExperienceResponses1.projectLink"></el-input>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>项目角色</div>
                                    <el-input  placeholder="请输入项目角色" v-model="recruitResumeProjectExperienceResponses1.projectRole"></el-input>
                                </div>
                                <div class="rightForm rightForm1">
                                    <div class="infoName"><i>*</i>项目周期</div>
                                    <el-date-picker
                                        v-model="recruitResumeProjectExperienceResponses1.projectCycleBegin"
                                        type="month"
                                        style="width: 120px;"
                                        :picker-options="{disabledDate:data=>startDatePicker(data,recruitResumeProjectExperienceResponses1.projectCycleEnd)}"
                                        placeholder="开始">
                                    </el-date-picker><i style="margin: 0 10px;">至</i><el-date-picker
                                        v-model="recruitResumeProjectExperienceResponses1.projectCycleEnd"
                                        type="month"
                                        style="width: 120px;"
                                        :class="[recruitResumeProjectExperienceResponses1.timeEndNow?'time-picker':'']"
                                        :picker-options="pickerWorkOptions_e2"
                                        :placeholder="recruitResumeProjectExperienceResponses1.timeEndNow?'至今':'请选择'">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="textareaBox">
                                <div class="infoName"><i>*</i>项目描述</div>
                                <el-input
                                    type="textarea"
                                    placeholder="请输入项目描述..."
                                    v-model="recruitResumeProjectExperienceResponses1.projectDes"
                                    maxlength="1500"
                                    show-word-limit
                                    style="width: 575px;height: 108px;"
                                ></el-input>
                            </div>
                            <div class="textareaBox">
                                <div class="infoName">项目业绩（选填）</div>
                                <el-input
                                    type="textarea"
                                    placeholder="请输入项目业绩..."
                                    v-model="recruitResumeProjectExperienceResponses1.projectPerformance"
                                    maxlength="300"
                                    show-word-limit
                                    style="width: 575px;height: 108px;"
                                ></el-input>
                            </div>
                            <div class="butBox1">
                                <span class="save" @click="saveEditExperience1">保存</span><span class="close2" @click="isShow5=false,projectHover=null">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view6">
                    <div class="box">
                        <div class="education" v-if="!isShow6 && recruitResumeEducationExperienceResponses.length">
                            <p class="nameTitle clearfix">教育经历<span @click="showEdit(6)"><img src="https://image.manamana.net/1659691179000_NRBoGGYI" alt="">添加</span></p>
                            <div :class="[educationHover==i+1?'educationList clearfix educationHover':'educationList clearfix']" v-for="(item,i) in recruitResumeEducationExperienceResponses" :key="i" @mouseenter="educationHover=i+1" @mouseleave="educationHover=null">
                                <div class="educationLeft">
                                    <p class="schoolName clearfix"><span class="name">{{item.schoolName}}</span><span>{{item.schoolStartTime | formatDate("YYYY.MM")}} - <i v-if="item.schoolEndTime">{{item.schoolEndTime | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></p>
                                    <p class="tags">{{getEducation(item.education)}} | {{item.major}}</p>
                                </div>
                                <div class="educationRight" v-if="educationHover==i+1"><span @click="showEdit(6,i+1)"><img src="https://image.manamana.net/1657265209000_bUmMSfnG" alt="">编辑</span><span @click="deteleFile(5,item.id)"><img src="https://image.manamana.net/1657268061000_gpqgGfEY" alt="">删除</span></div>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!isShow6 && !recruitResumeEducationExperienceResponses.length">
                            <p class="improved">教育经历<span>待完善</span></p>
                            <div class="addText" @click="showEdit(6)">
                                立即添加
                            </div>
                        </div>
                        <div class="editEducation" v-if="isShow6">
                            <p class="infoTitle">编辑教育经历<span>保存后可继续添加下一条</span></p>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>学校名称</div>
                                    <el-input  placeholder="请输入学校名称" v-model="recruitResumeEducationExperienceResponses1.schoolName"></el-input>
                                </div>
                                <div class="rightForm rightForm1">
                                    <div class="infoName"><i>*</i>学历</div>
                                    <el-select
                                        v-model="recruitResumeEducationExperienceResponses1.education"
                                        filterable
                                        style="width: 274px;"
                                        placeholder="请选择学历"
                                        >
                                        <el-option
                                            :label="item.label"
                                            :value="item.value"
                                            v-for="item in educationList"
                                            :key="item.value"
                                        ></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="formBox clearfix">
                                <div class="leftForm">
                                    <div class="infoName"><i>*</i>专业</div>
                                    <el-input  placeholder="请输入专业" v-model="recruitResumeEducationExperienceResponses1.major"></el-input>
                                </div>
                                <div class="rightForm rightForm1">
                                    <div class="infoName"><i>*</i>在校时间</div>
                                    <el-date-picker
                                        v-model="recruitResumeEducationExperienceResponses1.schoolStartTime"
                                        type="month"
                                        style="width: 120px;"
                                        :picker-options="{disabledDate:data=>startDatePicker(data,recruitResumeEducationExperienceResponses1.schoolEndTime)}"
                                        placeholder="开始">
                                    </el-date-picker><i style="margin: 0 10px;">至</i><el-date-picker
                                        v-model="recruitResumeEducationExperienceResponses1.schoolEndTime"
                                        type="month"
                                        style="width: 120px;"
                                        :class="[recruitResumeEducationExperienceResponses1.timeEndNow?'time-picker':'']"
                                        :picker-options="pickerWorkOptions_e3"
                                        :placeholder="recruitResumeEducationExperienceResponses1.timeEndNow?'至今':'请选择'">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="butBox1">
                                <span class="save" @click="saveEditEducation">保存</span><span class="close2" @click="isShow6=false,educationHover=null">取消</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="view7">
                    <div class="box">
                        <div class="video" v-if="recruitResumeProductShowResponse.videoDomains.length">
                            <p class="nameTitle clearfix">作品展示<span @click="showEdit(7)"><img src="https://image.manamana.net/1659691179000_NRBoGGYI" alt="">添加</span></p>
                            <div class="videoList clearfix">
                                <div class="videoLi" v-for="(item,i) in recruitResumeProductShowResponse.videoDomains" :key="i" @click="gotoVideo(item.id)">
                                    <img :src="item.thumb | imageUrl('',277,160)" alt="">
                                    <p class="videoTitle">{{item.title}}</p>
                                    <p class="tags"><span v-for="(tag,y) in item.categoryTagGroupInfoList" :key="y">{{tag}}</span></p>
                                </div>
                            </div>
                        </div>
                        <div class="improvedBox" v-if="!recruitResumeProductShowResponse.videoDomains.length">
                            <p class="improved">作品展示</p>
                            <div class="addText" @click="showEdit(7)">
                                立即添加
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fileBox" :style="{'left': right}">
                <p class="fileName">附件管理</p>
                <div class="uploadFile1" v-if="!resumeFile" @click="isShowuploadPop(1)">上传简历附件</div>
                <div class="changeUpload clearfix" v-else>
                    <img src="https://image.manamana.net/1657273108000_gzWWArXf" alt="">
                    <div class="rightBox">
                        <p class="wordName">{{resumeFile.name}}</p>
                        <p class="butBox"><span @click="isShowuploadPop(1)">重新上传</span><span @click="deteleFile(1,1)">删除</span></p>
                    </div>
                </div>
                <div class="uploadFile2" v-if="!videoFile" @click="isShowuploadPop(2)">上传作品集附件</div>
                <div class="changeUpload clearfix" v-else>
                    <img src="https://image.manamana.net/1657273735000_xMctCucr" alt="">
                    <div class="rightBox">
                        <p class="wordName">{{videoFile.name}}</p>
                        <p class="butBox"><span @click="isShowuploadPop(2)">重新上传</span><span @click="deteleFile(1,2)">删除</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="popBox" v-if="isShowPop1">
            <div class="box1">
                <div class="title">
                    温馨提示
                    <span @click="close1"></span>
                </div>
                <div class="content">您尚有内容没有保存，确定要离开吗？</div>
                <div class="but">
                    <span class="butClose" @click="close1">取消</span><span class="butConfin" @click="confinLeave">确定</span>
                </div>
            </div>
        </div>
        <div class="popBox" v-if="isShowPop3">
            <div class="box1">
                <div class="title">
                    温馨提示
                    <span @click="isShowPop3=false"></span>
                </div>
                <div class="content">删除后不可恢复，确定要删除吗？</div>
                <div class="but">
                    <span class="butClose" @click="isShowPop3=false">取消</span><span class="butConfin" @click="confinDetele">确定</span>
                </div>
            </div>
        </div>
        <div class="popBox" v-if="isShow7">
          <div class="box2">
            <div class="title">
                请选择视频作品
                <span @click="close2"></span>
            </div>
            <div class="videoBox">
                <div class="clearfix" v-if="videoList.length">
                <div class="video" v-for="(item,i) in videoList" :key="i">
                    <div class="imgBox" @click="changeVideo(item)">
                      <img class="img1" :src="item.thumb | imageUrl('',460,260)" alt />
                      <span>{{getVideoIndex(item.id)}}</span>
                      <img
                          class="img2"
                          v-if="getVideoIndex(item.id)"
                          src="https://image.manamana.net/1650432245000_NWqnHAXW"
                          alt
                      />
                      <i v-else></i>
                      <div class="bg"></div>
                    </div>
                    <div class="videoTitle">{{item.title}}</div>
                </div>
                </div>
                <div v-else class="noData1">
                <p>{{$t('recruit.您尚未上传任何项目案例视频，发布后即可添加！')}}</p>
                <div class="but" @click="gotoUploadVideo">{{$t('recruit.去上传')}}</div>
                </div>
                <pagination
                :totalRecord="totalRecord1"
                :pageSize="6"
                :pageIndex="pageIndex1"
                @OnCurrentChanged="changePage1"
                />
            </div>
            <div class="but" v-if="videoList.length">
                <span class="butLeft" @click="gotoUploadVideo">上传作品</span><span class="butRight" @click="submitAnli">{{$t('recruit.提交')}}</span>
            </div>
            </div>
      </div>
      <div class="popBox" v-if="popShow">
        <div class="box">
          <div class="title">
            上传附件
            <span @click="closePop"></span>
          </div>
          <div class="content" v-if="popShow1">
            <div class="name">{{fileType == 1 ?'请上传简历附件':'请上传作品集附件'}}</div>
            <div class="text">简历仅支持Word、PDF、PPT格式的文件，文件大小需小于10M；</div>
            <div class="but" @click="uploadFile">{{fileType == 1 ?'上传简历附件':'上传作品集附件'}}</div>
          </div>
          <div class="content" v-if="popShow2">
            <img class="img1" src="https://image.manamana.net/1652418599000_TZCUgbko" alt />
            <div class="uploadNumber">{{proNumber}}</div>
            <div class="uploadName">{{fileName}}</div>
            <div class="progress">
              <span :style="{width: proWidth + '%'}"></span>
            </div>
          </div>
        </div>
      </div>
      <input type="file" style="display: none" class="upInputSure" @change="upVideo" accept=".doc,.docx,.ppt,.pptx,.pdf" />
    </div>
    <cropImg
        ref="cropComponent"
        :dialogWidth="dialogWidth"
        :dialogHeight="dialogHeight"
        :cropWidth="cropWidth"
        :cropHeight="cropHeight"
        :minWidth="minWidth"
        :minHeight="minHeight"
        :showtext="showText"
        :fixed="fixed"
        :fixedBox="fixedBox"
        :fixedNumber="fixedNumber"
        :original="original"
        @update-img="updateImage"
    ></cropImg>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import Pagination from "@/components/v2/Pagination";
import cropImg from "@/components/CropImg.vue";
import * as qiniu from "qiniu-js";
export default {
  name: "MyResume",
  metaInfo() {
    return {
      title: "我的简历 | MANA"
    };
  },
  data() {
    let self = this;
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      pickerWorkOptions_e1: {
        disabledDate: time => {
          let data = new Date(
            self.recruitResumeWorkExperienceResponses1.workBeginTime
          );
          return (
            time.getTime() < data.getTime() ||
            time.getTime() > Date.now() - 8.64e6
          );
        },
        shortcuts: [
          {
            text: "至今",
            onClick(picker) {
              picker.$emit("pick", "");
              self.data_set_simulateVue_to_date(self, 1).then(miu => {});
            }
          }
        ]
      },
      pickerWorkOptions_e2: {
        disabledDate: time => {
          let data = new Date(
            self.recruitResumeProjectExperienceResponses1.projectCycleBegin
          );
          return (
            time.getTime() < data.getTime() ||
            time.getTime() > Date.now() - 8.64e6
          );
        },
        shortcuts: [
          {
            text: "至今",
            onClick(picker) {
              picker.$emit("pick", "");
              self.data_set_simulateVue_to_date(self, 2).then(miu => {});
            }
          }
        ]
      },
      pickerWorkOptions_e3: {
        disabledDate: time => {
          let data = new Date(
            self.recruitResumeEducationExperienceResponses1.schoolStartTime
          );
          return (
            time.getTime() < data.getTime() ||
            time.getTime() > Date.now() - 8.64e6
          );
        },
        shortcuts: [
          {
            text: "至今",
            onClick(picker) {
              picker.$emit("pick", "");
              self.data_set_simulateVue_to_date(self, 3).then(miu => {});
            }
          }
        ]
      },
      dialogWidth: 300,
      dialogHeight: 300,
      cropWidth: 180,
      cropHeight: 180,
      minWidth: 180,
      minHeight: 180,
      countryOptions: [],
      fixed: true,
      fixedNumber: [1, 1],
      fixedBox: false,
      original: false,
      showText: true,
      left: 0,
      right: 0,
      type: 1,
      typeList: [
        "个人信息",
        "个人优势",
        "求职期望",
        "工作经历",
        "项目经历",
        "教育经历",
        "作品展示"
      ],
      hoverBox1: false,
      hoverBox2: false,
      expectHover: null,
      experienceHover: null,
      projectHover: null,
      educationHover: null,
      videoList: [],
      cityOptions: [],
      jobList: [
        { status: "1", title: "随时入职" },
        { status: "2", title: "考虑机会" },
        { status: "3", title: "暂不考虑" }
      ],
      educationList: [
        { label: "其他", value: "1" },
        { label: "大专", value: "2" },
        { label: "本科", value: "3" },
        { label: "硕士", value: "4" },
        { label: "博士", value: "5" }
      ],
      advantageText: "",
      salaryStart: null,
      salaryEnd: null,
      selectVideoList: [],
      totalRecord1: 0,
      pageIndex1: 1,
      isShowPop1: false,
      isShowPop3: false,
      isShow7: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
      indexType: 0,
      cityList: [],
      recruitResumeAdvantageResponse: {}, //个人优势
      recruitResumeAdvantageResponse1: {}, //个人优势
      recruitResumeBaseResponse: {}, //基本信息
      recruitResumeBaseResponse1: {}, //基本信息
      recruitResumeEducationExperienceResponses: [], //教育经历
      recruitResumeEducationExperienceResponses1: {}, //教育经历
      recruitResumeExpectationResponses: [], //求职期望
      recruitResumeExpectationResponses1: {}, //求职期望
      recruitResumeProductShowResponse: {}, //作品展示
      recruitResumeProjectExperienceResponses: [], //项目经历
      recruitResumeProjectExperienceResponses1: {}, //项目经历
      recruitResumeWorkExperienceResponses: [], //工作经历
      recruitResumeWorkExperienceResponses1: {}, //工作经历
      resumeFile: null,
      videoFile: null,
      popShow: false,
      popShow1: false,
      popShow2: false,
      proWidth: 0,
      proNumber: 0,
      fileName: "",
      key: null,
      fileType: null,
      deteleType: null,
      deleteId: null,
      deleteIndex: null,
      isShowOk: true,
      moneyList: [
        {'label': '面议', value: 9999},
        {'label': '1K', value: 1},
        {'label': '2K', value: 2},
        {'label': '3K', value: 3},
        {'label': '4K', value: 4},
        {'label': '5K', value: 5},
        {'label': '6K', value: 6},
        {'label': '7K', value: 7},
        {'label': '8K', value: 8},
        {'label': '9K', value: 9},
        {'label': '10K', value: 10},
        {'label': '11K', value: 11},
        {'label': '12K', value: 12},
        {'label': '13K', value: 13},
        {'label': '14K', value: 14},
        {'label': '15K', value: 15},
        {'label': '16K', value: 16},
        {'label': '17K', value: 17},
        {'label': '18K', value: 18},
        {'label': '19K', value: 19},
        {'label': '20K', value: 20},
        {'label': '21K', value: 21},
        {'label': '22K', value: 22},
        {'label': '23K', value: 23},
        {'label': '24K', value: 24},
        {'label': '25K', value: 25},
        {'label': '26K', value: 26},
        {'label': '27K', value: 27},
        {'label': '28K', value: 28},
        {'label': '29K', value: 29},
        {'label': '30K', value: 30},
        {'label': '35K', value: 35},
        {'label': '40K', value: 40},
        {'label': '45K', value: 45},
        {'label': '50K', value: 50},
        {'label': '55K', value: 55},
        {'label': '60K', value: 60},
        {'label': '65K', value: 65},
        {'label': '70K', value: 70},
        {'label': '75K', value: 75},
        {'label': '80K', value: 80},
        {'label': '85K', value: 85},
        {'label': '90K', value: 90},
        {'label': '95K', value: 95},
        {'label': '100K', value: 100},
        {'label': '110K', value: 110},
        {'label': '120K', value: 120},
        {'label': '130K', value: 130},
        {'label': '140K', value: 140},
        {'label': '150K', value: 150},
        {'label': '160K', value: 160},
        {'label': '170K', value: 170},
        {'label': '180K', value: 180},
        {'label': '190K', value: 190},
        {'label': '200K', value: 200},
        {'label': '210K', value: 210},
        {'label': '220K', value: 220},
        {'label': '230K', value: 230},
        {'label': '240K', value: 240},
        {'label': '250K', value: 250},
        {'label': '260K', value: 260},
      ],
    };
  },
  components: {
    MainLayout,
    Pagination,
    cropImg
  },
  created() {
    this.getCity();
    this.getAllCitys();
  },
  watch: {
    'recruitResumeExpectationResponses1.positionName'(val) {
      if (val) {
        if (val.length > 30) {
          this.$message.error("期望职位长度不能超过30！");
          this.recruitResumeExpectationResponses1.positionName = null;
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      var width = document.documentElement.clientWidth;
      if (width < 1440) {
        width = 1440;
      }
      this.left = (width - 1110) / 2 + "px";
      this.right = (width - 1110) / 2 + 160 + 60 + 635 + "px";
    });
    this.getInfo1();
    window.onbeforeunload = e => {
      if (
        this.isShow1 ||
        this.isShow2 ||
        this.isShow3 ||
        this.isShow4 ||
        this.isShow5 ||
        this.isShow6
      ) {
        // 通知浏览器不要执行与事件关联的默认动作
        e.preventDefault();
        // Chrome 需要 returnValue 被设置成空字符串
        e.returnValue = "";
      } else {
        return;
      }
    };
  },
  destroyed() {
    // 取消对事件的监听
    window.onbeforeunload = null;
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    }
  },
  beforeRouteLeave(to, from, next) {
    next(false);
    if (
      this.isShow1 ||
      this.isShow2 ||
      this.isShow3 ||
      this.isShow4 ||
      this.isShow5 ||
      this.isShow6
    ) {
      // 这里需要elementui的支持，如果使用其他界面组件自行替换即可
      this.$confirm(
        this.$t("video.您所填写的信息尚未保存"),
        this.$t("video.确定要离开吗？"),
        {
          confirmButtonText: this.$t("video.确定"),
          cancelButtonText: this.$t("video.取消"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          // 正常跳转
          next();
        })
        .catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1);
        });
    } else {
      next();
    }
  },
  methods: {
    handleSelect(item) {
      this.recruitResumeExpectationResponses1.positionName = item.name;
    },
    querySearchAsync(query, cb) {
        if (query !== '') {
          this.$http
            .get("/api/u/recruit/info/search/position_name/" + query)
            .then(res => {
              var data = res.data;
              data.forEach(item => {
                this.$set(item, 'value', item.umName)
              })
              cb(data)
            });
        }
    },
    getShow(i) {
      if (this.recruitResumeBaseResponse.idType == 1) {
        if (!this.recruitResumeAdvantageResponse.advantage ||
          !this.recruitResumeExpectationResponses.length ||
          !this.recruitResumeEducationExperienceResponses.length ||
          !this.recruitResumeWorkExperienceResponses.length
        ){
          this.isShowOk = true
        } else {
          this.isShowOk = false
        }
      }
      if (this.recruitResumeBaseResponse.idType == 2) {
        if (!this.recruitResumeAdvantageResponse.advantage ||
          !this.recruitResumeExpectationResponses.length ||
          !this.recruitResumeEducationExperienceResponses.length
        ){
          this.isShowOk = true
        } else {
          this.isShowOk = false
        }
      }
      if (i == 1) {
        if (this.recruitResumeBaseResponse.idType){
          return false
        }
      }
      if (i == 2) {
        if (this.recruitResumeAdvantageResponse.advantage) {
          return false
        }
      }
      if (i == 3) {
        if (this.recruitResumeExpectationResponses.length) {
          return false
        }
      }
      if (i == 4) {
        if (!this.recruitResumeBaseResponse.idType){
          return false
        }
        if (this.recruitResumeBaseResponse.idType == 1) {
          if (this.recruitResumeWorkExperienceResponses.length) {
            return false
          }
        }
        if (this.recruitResumeBaseResponse.idType == 2) {
          return false
        } 
      }
      if (i == 5) {
        return false
      }
      if (i == 6) {
        if (this.recruitResumeEducationExperienceResponses.length) {
          return false
        }
      }
      if (i == 7) {
        return false
      }
      return true
    },
    startDatePicker(time, etime) {
      let data = new Date(etime);
      return (
        time.getTime() > data.getTime() || time.getTime() > Date.now() - 8.64e6
      );
    },
    data_set_simulateVue_to_date(self, index) {
      if (index == 1) {
        self.recruitResumeWorkExperienceResponses1.timeEndNow = true;
      }
      if (index == 2) {
        self.recruitResumeProjectExperienceResponses1.timeEndNow = true;
      }
      if (index == 3) {
        self.recruitResumeEducationExperienceResponses1.timeEndNow = true;
      }
    },
    getCityName(city) {
      if (city) {
        var cityList = city.split(" ");
        return cityList[cityList.length - 1];
      } else {
        return "";
      }
    },
    getInfo1() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then(response => {
          if (response.code !== "ServiceError") {
            this.getInfo(response.data.userId);
            if (
              response.data.userType === 2 &&
              response.data.isCertification === 1
            ) {
              this.$router.push("/MyRecruit");
            }
          } else {
            this.loginout();
          }
        });
      }
    },
    getResumeCheck() {
      this.$http
        .get("/api/u/recruit/resume/online/info/resume/check")
        .then(res => {
          if (res.code == "OK") {
            if (res.data.isOk == 1) {
              //简历已完善
            } else {
              //简历未完善
              // 
              if (!this.recruitResumeBaseResponse.idType) {
                this.showEdit(1);
              }
            }
          }
        });
    },
    deteleFile(index, type) {
      if (index == 1) {
        this.deteleType = type;
      } else {
        this.deleteId = type;
      }
      this.deleteIndex = index;
      this.isShowPop3 = true;
    },
    confinDetele() {
      if (this.deleteIndex == 1) {
        var id = this.deteleType == 1 ? this.resumeFile.id : this.videoFile.id;
        this.$http
          .delete("/api/u/recruit/resume/online/info/file/" + id)
          .then(res => {
            this.$message.success(res.message);
            this.isShowPop3 = false;
            this.$http
              .get("/api/u/recruit/resume/online/info/file")
              .then(resp => {
                if (resp.code == "OK") {
                  this.resumeFile = null;
                  this.videoFile = null;
                  if (resp.data.length) {
                    for (let i = 0; i < resp.data.length; i++) {
                      if (resp.data[i].type == 1) {
                        this.resumeFile = resp.data[i];
                      }
                      if (resp.data[i].type == 2) {
                        this.videoFile = resp.data[i];
                      }
                    }
                  }
                }
              });
          });
      }
      if (this.deleteIndex == 2) {
        this.deleteExpect(this.deleteId);
      }
      if (this.deleteIndex == 3) {
        this.deteleExperience(this.deleteId);
      }
      if (this.deleteIndex == 4) {
        this.deteleEditExperience1(this.deleteId);
      }
      if (this.deleteIndex == 5) {
        this.deleteEditEducation(this.deleteId);
      }
    },
    getFileList() {
      var params = {
        name: this.fileName,
        path: this.key,
        type: this.fileType
      };
      this.$http
        .post("/api/u/recruit/resume/online/info/file", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.popShow = false;
            this.popShow1 = false;
            this.popShow2 = false;
            this.$http
              .get("/api/u/recruit/resume/online/info/file")
              .then(resp => {
                if (resp.code == "OK") {
                  this.resumeFile = null;
                  this.videoFile = null;
                  if (resp.data.length) {
                    for (let i = 0; i < resp.data.length; i++) {
                      if (resp.data[i].type == 1) {
                        this.resumeFile = resp.data[i];
                      }
                      if (resp.data[i].type == 2) {
                        this.videoFile = resp.data[i];
                      }
                    }
                  }
                }
              });
          }
        });
    },
    upVideo(e) {
      var $this = this;
      var fileName = e.target.files[0].name;
      const type = e.target.files[0].type;
      if (e.target.files[0].size / 1024 / 1024 > 10) {
        this.$message.info(this.$t("works.文件不能大于10M"));
        return;
      }

      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.error($this.$t("global.上传失败"));
      };

      var complete = function(res) {
        $this.key = res.key;
        $this.getFileList();
      };

      var next = function(response) {
        var total = response.total;
        $this.popShow1 = false;
        $this.popShow2 = true;
        $this.fileName = e.target.files[0].name;
        $this.proWidth = parseInt(total.percent);
        $this.proNumber = `${$this.$t("recruit.正在上传")}${parseInt(
          total.percent
        )}%`;
      };
      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null
      };
      var putExtra = {
        fname: fileName.split(".")[0],
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/token/file").then(res => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    uploadFile() {
      document.querySelector(".upInputSure").value = "";
      document.querySelector(".upInputSure").click();
    },
    isShowuploadPop(type) {
      this.fileType = type;
      this.popShow = true;
      this.popShow1 = true;
    },
    closePop() {
      this.popShow = false;
      this.popShow1 = false;
      this.popShow2 = false;
    },
    saveEditEducation() {
      if (!this.recruitResumeEducationExperienceResponses1.schoolName) {
        this.$message.error("请输入学校名称");
        return;
      }
      if (!this.recruitResumeEducationExperienceResponses1.education) {
        this.$message.error("请选择学历");
        return;
      }
      if (!this.recruitResumeEducationExperienceResponses1.major) {
        this.$message.error("请输入专业");
        return;
      }
      if (!this.recruitResumeEducationExperienceResponses1.schoolStartTime) {
        this.$message.error("请选择在校开始时间");
        return;
      }
      if (
        !this.recruitResumeEducationExperienceResponses1.timeEndNow &&
        !this.recruitResumeEducationExperienceResponses1.schoolEndTime
      ) {
        this.$message.error("请选择在校结束时间");
        return;
      }
      if (this.recruitResumeEducationExperienceResponses1.id) {
        var params = {
          id: this.recruitResumeEducationExperienceResponses1.id,
          schoolName: this.recruitResumeEducationExperienceResponses1
            .schoolName,
          education: this.recruitResumeEducationExperienceResponses1.education,
          major: this.recruitResumeEducationExperienceResponses1.major,
          schoolStartTime: this.recruitResumeEducationExperienceResponses1
            .schoolStartTime,
          schoolEndTime: this.recruitResumeEducationExperienceResponses1
            .schoolEndTime
        };
        this.$http
          .put(
            "/api/u/recruit/resume/online/info/education/experience",
            params,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/education/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeEducationExperienceResponses = resp.data;
                    this.isShow6 = false;
                    this.educationHover = null;
                  }
                });
            }
          });
      } else {
        var params = {
          schoolName: this.recruitResumeEducationExperienceResponses1
            .schoolName,
          education: this.recruitResumeEducationExperienceResponses1.education,
          major: this.recruitResumeEducationExperienceResponses1.major,
          schoolStartTime: this.recruitResumeEducationExperienceResponses1
            .schoolStartTime,
          schoolEndTime: this.recruitResumeEducationExperienceResponses1
            .schoolEndTime
        };
        this.$http
          .post(
            "/api/u/recruit/resume/online/info/education/experience",
            params,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/education/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeEducationExperienceResponses = resp.data;
                    this.isShow6 = false;
                    this.educationHover = null;
                  }
                });
            }
          });
      }
    },
    saveEditExperience1() {
      if (!this.recruitResumeProjectExperienceResponses1.projectName) {
        this.$message.error("请输入项目名称");
        return;
      }
      const reg = /^http(s?):\/\//;
      if (
        this.recruitResumeProjectExperienceResponses1.projectLink &&
        !reg.test(this.recruitResumeProjectExperienceResponses1.projectLink)
      ) {
        this.$message({
          message: this.$t("works.链接应以http://或 https://开头"),
          type: "error",
          duration: 2000
        });
        return;
      }
      if (!this.recruitResumeProjectExperienceResponses1.projectRole) {
        this.$message.error("请输入项目角色");
        return;
      }
      if (!this.recruitResumeProjectExperienceResponses1.projectCycleBegin) {
        this.$message.error("请选择项目开始周期");
        return;
      }
      if (
        !this.recruitResumeProjectExperienceResponses1.timeEndNow &&
        !this.recruitResumeProjectExperienceResponses1.projectCycleEnd
      ) {
        this.$message.error("请选择项目结束周期");
        return;
      }
      if (!this.recruitResumeProjectExperienceResponses1.projectDes) {
        this.$message.error("请输入项目描述");
        return;
      }
      if (this.recruitResumeProjectExperienceResponses1.id) {
        var params = {
          id: this.recruitResumeProjectExperienceResponses1.id,
          projectName: this.recruitResumeProjectExperienceResponses1
            .projectName,
          projectLink: this.recruitResumeProjectExperienceResponses1
            .projectLink,
          projectRole: this.recruitResumeProjectExperienceResponses1
            .projectRole,
          projectCycleBegin: this.recruitResumeProjectExperienceResponses1
            .projectCycleBegin,
          projectCycleEnd: this.recruitResumeProjectExperienceResponses1
            .projectCycleEnd,
          projectDes: this.recruitResumeProjectExperienceResponses1.projectDes,
          projectPerformance: this.recruitResumeProjectExperienceResponses1
            .projectPerformance
        };
        this.$http
          .put("/api/u/recruit/resume/online/info/project/experience", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/project/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeProjectExperienceResponses = resp.data;
                    this.isShow5 = false;
                    this.projectHover = null;
                  }
                });
            }
          });
      } else {
        var params = {
          projectName: this.recruitResumeProjectExperienceResponses1
            .projectName,
          projectLink: this.recruitResumeProjectExperienceResponses1
            .projectLink,
          projectRole: this.recruitResumeProjectExperienceResponses1
            .projectRole,
          projectCycleBegin: this.recruitResumeProjectExperienceResponses1
            .projectCycleBegin,
          projectCycleEnd: this.recruitResumeProjectExperienceResponses1
            .projectCycleEnd,
          projectDes: this.recruitResumeProjectExperienceResponses1.projectDes,
          projectPerformance: this.recruitResumeProjectExperienceResponses1
            .projectPerformance
        };
        this.$http
          .post(
            "/api/u/recruit/resume/online/info/project/experience",
            params,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/project/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeProjectExperienceResponses = resp.data;
                    this.isShow5 = false;
                    this.projectHover = null;
                  }
                });
            }
          });
      }
    },
    saveEditExperience() {
      if (!this.recruitResumeWorkExperienceResponses1.companyName) {
        this.$message.error("请输入公司名称");
        return;
      }
      if (!this.recruitResumeWorkExperienceResponses1.positionName) {
        this.$message.error("请输入职位名称");
        return;
      }
      if (!this.recruitResumeWorkExperienceResponses1.workBeginTime) {
        this.$message.error("请选择在职开始时间");
        return;
      }
      if (
        !this.recruitResumeWorkExperienceResponses1.timeEndNow &&
        !this.recruitResumeWorkExperienceResponses1.workEndTime
      ) {
        this.$message.error("请选择在职结束时间");
        return;
      }
      if (!this.recruitResumeWorkExperienceResponses1.workContent) {
        this.$message.error("请输入工作内容");
        return;
      }
      if (this.recruitResumeWorkExperienceResponses1.id) {
        var params = {
          id: this.recruitResumeWorkExperienceResponses1.id,
          companyName: this.recruitResumeWorkExperienceResponses1.companyName,
          positionName: this.recruitResumeWorkExperienceResponses1.positionName,
          workBeginTime: this.recruitResumeWorkExperienceResponses1
            .workBeginTime,
          workEndTime: this.recruitResumeWorkExperienceResponses1.workEndTime,
          workContent: this.recruitResumeWorkExperienceResponses1.workContent
        };
        this.$http
          .put("/api/u/recruit/resume/online/info/work/experience", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/work/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeWorkExperienceResponses = resp.data;
                    this.isShow4 = false;
                    this.experienceHover = null;
                  }
                });
            }
          });
      } else {
        var params = {
          companyName: this.recruitResumeWorkExperienceResponses1.companyName,
          positionName: this.recruitResumeWorkExperienceResponses1.positionName,
          workBeginTime: this.recruitResumeWorkExperienceResponses1
            .workBeginTime,
          workEndTime: this.recruitResumeWorkExperienceResponses1.workEndTime,
          workContent: this.recruitResumeWorkExperienceResponses1.workContent
        };
        this.$http
          .post("/api/u/recruit/resume/online/info/work/experience", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/work/experience")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeWorkExperienceResponses = resp.data;
                    this.isShow4 = false;
                    this.experienceHover = null;
                  }
                });
            }
          });
      }
    },
    saveEditExpect() {
      if (!this.recruitResumeExpectationResponses1.positionName) {
        this.$message.error("请输入期望职位");
        return;
      }
      if (!this.recruitResumeExpectationResponses1.cityId) {
        this.$message.error("请选择工作城市");
        return;
      }
      // if (!this.recruitResumeExpectationResponses1.salaryBegin) {
      //   this.$message.error("请选择期望薪资");
      //   return;
      // }
      // if (
      //   this.recruitResumeExpectationResponses1.salaryBegin &&
      //   this.recruitResumeExpectationResponses1.salaryBegin !== 9999 &&
      //   !this.recruitResumeExpectationResponses1.salaryEnd
      // ) {
      //   this.$message.error("请选择期望薪资");
      //   return;
      // }
      if (this.recruitResumeExpectationResponses1.salaryBegin&&this.recruitResumeExpectationResponses1.salaryBegin==9999) {
        this.recruitResumeExpectationResponses1.negotiable = true;
      } else {
        if (!this.recruitResumeExpectationResponses1.salaryBegin) {
          this.$message.error(this.$t("recruit.请输入薪资范围"));
          return;
        }
        if (!this.recruitResumeExpectationResponses1.salaryEnd) {
          this.$message.error(this.$t("recruit.请输入薪资范围"));
          return;
        }
      }
      if (this.recruitResumeExpectationResponses1.id) {
        var params = {
          cityId: this.recruitResumeExpectationResponses1.cityId,
          negotiable:
            this.recruitResumeExpectationResponses1.salaryBegin == 9999
              ? "1"
              : "0",
          salaryBegin: this.recruitResumeExpectationResponses1.salaryBegin == 9999 ? null : this.recruitResumeExpectationResponses1.salaryBegin,
          salaryEnd: this.recruitResumeExpectationResponses1.salaryBegin == 9999 ? null : this.recruitResumeExpectationResponses1.salaryEnd,
          positionName: this.recruitResumeExpectationResponses1.positionName,
          id: this.recruitResumeExpectationResponses1.id
        };
        this.$http
          .put("/api/u/recruit/resume/online/info/expectation", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/expectation")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeExpectationResponses = resp.data;
                    this.isShow3 = false;
                    this.expectHover = null;
                  }
                });
            }
          });
      } else {
        var params = {
          cityId: this.recruitResumeExpectationResponses1.cityId,
          negotiable:
            this.recruitResumeExpectationResponses1.salaryBegin == 9999
              ? "1"
              : "0",
          salaryBegin: this.recruitResumeExpectationResponses1.salaryBegin == 9999 ? null : this.recruitResumeExpectationResponses1.salaryBegin,
          salaryEnd: this.recruitResumeExpectationResponses1.salaryBegin == 9999 ? null : this.recruitResumeExpectationResponses1.salaryEnd,
          positionName: this.recruitResumeExpectationResponses1.positionName
        };
        this.$http
          .post("/api/u/recruit/resume/online/info/expectation", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$message.success(res.message);
              this.$http
                .get("/api/u/recruit/resume/online/info/expectation")
                .then(resp => {
                  if (resp.code == "OK") {
                    this.recruitResumeExpectationResponses = resp.data;
                    this.isShow3 = false;
                    this.expectHover = null;
                  }
                });
            }
          });
      }
    },
    deleteExpect(id) {
      this.$http
        .delete("/api/u/recruit/resume/online/info/expectation/" + id)
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.isShowPop3 = false;
            this.$http
              .get("/api/u/recruit/resume/online/info/expectation")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeExpectationResponses = resp.data;
                }
              });
          }
        });
    },
    deteleExperience(id) {
      this.$http
        .delete("/api/u/recruit/resume/online/info/work/experience/" + id)
        .then(res => {
          if (res.code == "OK") {
            this.isShowPop3 = false;
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/work/experience")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeWorkExperienceResponses = resp.data;
                }
              });
          }
        });
    },
    deteleEditExperience1(id) {
      this.$http
        .delete("/api/u/recruit/resume/online/info/project/experience/" + id)
        .then(res => {
          if (res.code == "OK") {
            this.isShowPop3 = false;
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/project/experience")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeProjectExperienceResponses = resp.data;
                }
              });
          }
        });
    },
    deleteEditEducation(id) {
      this.$http
        .delete("/api/u/recruit/resume/online/info/education/experience/" + id)
        .then(res => {
          if (res.code == "OK") {
            this.isShowPop3 = false;
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/education/experience")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeEducationExperienceResponses = resp.data;
                }
              });
          }
        });
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    updateImage(img) {
      let $this = this;
      this.imgUrl = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.imgUrl, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }
      var observable;
      var subscription;
      var error = function(err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function(res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.recruitResumeBaseResponse1.avatar = res.key;
      };

      var next = function(response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/image/token").then(res => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    reUpload() {
      this.$refs.cropComponent.reUpload("3size");
    },
    saveAdvantage() {
      let params = {
        advantage: this.recruitResumeAdvantageResponse1.advantage
      };
      this.$http
        .post("/api/u/recruit/resume/online/info/advantage", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/advantage")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeAdvantageResponse = resp.data;
                  this.isShow2 = false;
                  this.hoverBox2 = false;
                }
              });
          }
        });
    },
    saveInfo() {
      if (!this.recruitResumeBaseResponse1.avatar) {
        this.$message.error("请上传头像！");
        return;
      }
      if (!this.recruitResumeBaseResponse1.name) {
        this.$message.error("请输入您的姓名！");
        return;
      }
      if (!this.recruitResumeBaseResponse1.birthday) {
        this.$message.error("请输入您的生日！");
        return;
      }
      if (!this.recruitResumeBaseResponse1.area) {
        this.$message.error("请输入所在城市！");
        return;
      }
      if (this.recruitResumeBaseResponse1.idType == 1) {
        if (!this.recruitResumeBaseResponse1.beginWorkTime) {
          this.$message.error("请选择参加工作时间！");
          return;
        }
      }
      if (!this.recruitResumeBaseResponse1.jobStatus) {
        this.$message.error("请选择求职状态！");
        return;
      }
      if (!this.recruitResumeBaseResponse1.mobile) {
        this.$message.error("请输入您的手机号！");
        return;
      }
      if (!this.recruitResumeBaseResponse1.email) {
        this.$message.error("请输入您的邮箱号！");
        return;
      }
      let params = {};
      if (this.recruitResumeBaseResponse1.idType == 1) {
        params = {
          area: this.recruitResumeBaseResponse1.area,
          avatar: this.recruitResumeBaseResponse1.avatar,
          name: this.recruitResumeBaseResponse1.name,
          gender: this.recruitResumeBaseResponse1.gender,
          birthday: this.recruitResumeBaseResponse1.birthday,
          idType: this.recruitResumeBaseResponse1.idType,
          beginWorkTime: this.recruitResumeBaseResponse1.beginWorkTime,
          jobStatus: this.recruitResumeBaseResponse1.jobStatus,
          wechatLink: this.recruitResumeBaseResponse1.wechatLink
        };
      } else {
        params = {
          area: this.recruitResumeBaseResponse1.area,
          avatar: this.recruitResumeBaseResponse1.avatar,
          name: this.recruitResumeBaseResponse1.name,
          gender: this.recruitResumeBaseResponse1.gender,
          birthday: this.recruitResumeBaseResponse1.birthday,
          idType: this.recruitResumeBaseResponse1.idType,
          jobStatus: this.recruitResumeBaseResponse1.jobStatus,
          wechatLink: this.recruitResumeBaseResponse1.wechatLink,
          beginWorkTime: null
        };
      }
      this.$http
        .post("/api/u/recruit/resume/online/info/base", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/base")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeBaseResponse = resp.data;
                  this.isShow1 = false;
                  this.hoverBox1 = false;
                }
              });
          }
        });
    },
    getBirthday(strBirthday) {
      let date = new Date(strBirthday);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let dd = date.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      strBirthday = y + "-" + MM + "-" + dd;
      var returnAge;
      var strBirthdayArr = strBirthday.split("-");
      var birthYear = strBirthdayArr[0];
      var birthMonth = strBirthdayArr[1];
      var birthDay = strBirthdayArr[2];
      var d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1;
      var nowDay = d.getDate();

      if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
      } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay; //日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          } else {
            var monthDiff = nowMonth - birthMonth; //月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          }
        } else {
          returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
      }

      return returnAge; //返回周岁年龄
    },
    getJobs(i) {
      if (i == 1) {
        return "随时入职";
      }
      if (i == 2) {
        return "考虑机会";
      }
      if (i == 3) {
        return "暂不考虑";
      }
    },
    getEducation(i) {
      if (i == 1) {
        return "其他";
      }
      if (i == 2) {
        return "大专";
      }
      if (i == 3) {
        return "本科";
      }
      if (i == 4) {
        return "硕士";
      }
      if (i == 5) {
        return "博士";
      }
    },
    getInfo(userId) {
      this.$http
        .get("/api/u/recruit/resume/online/info/" + userId)
        .then(res => {
          if (res.code == "OK") {
            this.recruitResumeAdvantageResponse =
              res.data.recruitResumeAdvantageResponse;
            this.recruitResumeBaseResponse = res.data.recruitResumeBaseResponse;
            this.recruitResumeEducationExperienceResponses =
              res.data.recruitResumeEducationExperienceResponses;
            this.recruitResumeExpectationResponses =
              res.data.recruitResumeExpectationResponses;
            if (res.data.recruitResumeFileResponse.length) {
              for (
                let i = 0;
                i < res.data.recruitResumeFileResponse.length;
                i++
              ) {
                if (res.data.recruitResumeFileResponse[i].type == 1) {
                  this.resumeFile = res.data.recruitResumeFileResponse[i];
                }
                if (res.data.recruitResumeFileResponse[i].type == 2) {
                  this.videoFile = res.data.recruitResumeFileResponse[i];
                }
              }
            } else {
              this.resumeFile = null;
              this.videoFile = null;
            }
            this.recruitResumeProductShowResponse =
              res.data.recruitResumeProductShowResponse;
            if (res.data.recruitResumeProductShowResponse.videoDomains.length) {
              var videoList =
                res.data.recruitResumeProductShowResponse.videoDomains;
              for (let i = 0; i < videoList.length; i++) {
                this.changeVideo(videoList[i]);
              }
            }
            this.recruitResumeProjectExperienceResponses =
              res.data.recruitResumeProjectExperienceResponses;
            this.recruitResumeWorkExperienceResponses =
              res.data.recruitResumeWorkExperienceResponses;
            this.getResumeCheck();
          }
        });
    },
    gotoPreview() {
      this.$http
        .get("/api/u/recruit/resume/online/info/resume/check")
        .then(res => {
          if (res.code == "OK") {
            if (res.data.isOk) {
              //简历已完善
              let routeData = this.$router.resolve({
                path: "/previewResume/" + this.peopleMessage.userId
              });
              window.open(routeData.href, "_blank");
            } else {
              //简历未完善
              this.$message("请先完善简历！");
            }
          }
        });
    },
    gotoVideo(id) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + id
      });
      window.open(routeData.href, "_blank");
    },
    showEdit(index, i) {
      if (
        !this.isShow1 &&
        !this.isShow2 &&
        !this.isShow3 &&
        !this.isShow4 &&
        !this.isShow5 &&
        !this.isShow6
      ) {
        if (index == 7) {
          this.getVideoList();
        } else {
          if (index == 1) {
            this.recruitResumeBaseResponse1 = JSON.parse(
              JSON.stringify(this.recruitResumeBaseResponse)
            );
            if (this.recruitResumeBaseResponse1.country == 0) {
              this.recruitResumeBaseResponse1.area = +this
              .recruitResumeBaseResponse.area;
            } else {
              this.recruitResumeBaseResponse1.area = null;
            }
            if (this.recruitResumeBaseResponse1.area == 0) {
              this.recruitResumeBaseResponse1.area = null;
            }
          }
          if (index == 2) {
            this.recruitResumeAdvantageResponse1 = JSON.parse(
              JSON.stringify(this.recruitResumeAdvantageResponse)
            );
          }
          if (index == 3 && i) {
            this.recruitResumeExpectationResponses1 = JSON.parse(
              JSON.stringify(this.recruitResumeExpectationResponses[i - 1])
            );
            if (this.recruitResumeExpectationResponses[i - 1].negotiable == 1) {
              this.recruitResumeExpectationResponses1.salaryBegin = 9999;
              this.recruitResumeExpectationResponses1.salaryEnd = null;
            }
          } else {
            this.recruitResumeExpectationResponses1 = {};
          }
          if (index == 4 && i) {
            this.recruitResumeWorkExperienceResponses1 = JSON.parse(
              JSON.stringify(this.recruitResumeWorkExperienceResponses[i - 1])
            );
            if (!this.recruitResumeWorkExperienceResponses1.workEndTime) {
              this.recruitResumeWorkExperienceResponses1.timeEndNow = true;
            }
          } else {
            this.recruitResumeWorkExperienceResponses1 = {};
          }
          if (index == 5 && i) {
            this.recruitResumeProjectExperienceResponses1 = JSON.parse(
              JSON.stringify(
                this.recruitResumeProjectExperienceResponses[i - 1]
              )
            );
            if (
              !this.recruitResumeProjectExperienceResponses1.projectCycleEnd
            ) {
              this.recruitResumeProjectExperienceResponses1.timeEndNow = true;
            }
          } else {
            this.recruitResumeProjectExperienceResponses1 = {};
          }
          if (index == 6 && i) {
            this.recruitResumeEducationExperienceResponses1 = JSON.parse(
              JSON.stringify(
                this.recruitResumeEducationExperienceResponses[i - 1]
              )
            );
            if (
              !this.recruitResumeEducationExperienceResponses1.schoolEndTime
            ) {
              this.recruitResumeEducationExperienceResponses1.timeEndNow = true;
            }
          } else {
            this.recruitResumeEducationExperienceResponses1 = {};
          }
          this["isShow" + index] = true;
        }
      } else {
        this.isShowPop1 = true;
        this.indexType = index;
      }
    },
    getAllCitys() {
      this.$http.get("/api/u/recruit/address/city").then(res => {
        if (res.code == "OK") {
          this.cityList = res.data;
        }
      });
    },
    confinLeave() {
      this.isShow1 = false;
      this.isShow2 = false;
      this.isShow3 = false;
      this.isShow4 = false;
      this.isShow5 = false;
      this.isShow6 = false;
      this.isShow7 = false;
      this.isShowPop1 = false;
      if (this.indexType == 7) {
        this.getVideoList();
      } else {
        this["isShow" + this.indexType] = true;
      }
    },
    gotoUploadVideo() {
      let routeData = this.$router.resolve({
        path: "/UpVideo"
      });
      window.open(routeData.href, "_blank");
    },
    submitAnli() {
      let params = {
        videoIds: this.selectVideoList.join(",")
      };
      this.$http
        .post("/api/u/recruit/resume/online/info/product/show", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.$http
              .get("/api/u/recruit/resume/online/info/product/show")
              .then(resp => {
                if (resp.code == "OK") {
                  this.recruitResumeProductShowResponse = resp.data;
                  this.isShow7 = false;
                }
              });
          }
        });
    },
    close2() {
      this.isShow7 = false;
    },
    close1() {
      this.isShowPop1 = false;
    },
    changePage1(index) {
      this.pageIndex1 = index;
      this.getVideoList();
    },
    getVideoIndex(id) {
      let index = this.selectVideoList.findIndex(val => val === id);
      if (this.selectVideoList.findIndex(val => val === id) !== -1) {
        return index + 1;
      }
    },
    changeVideo(item) {
      if (this.selectVideoList.length) {
        let index = this.selectVideoList.findIndex(val => val === item["id"]);
        if (index !== -1) {
          this.selectVideoList.splice(index, 1);
        } else {
          if (this.selectVideoList.length >= 10) {
            this.$message.error("最多添加10个作品！");
            return;
          }
          this.selectVideoList.push(item.id);
        }
      } else {
        this.selectVideoList.push(item.id);
      }
    },
    getVideoList() {
      var params = {
        userId: this.peopleMessage.userId,
        order: 0,
        pageIndex: this.pageIndex1,
        pageSize: 6
      };
      this.$http.get("/api/mobile/2.0/u/getVideoList", { params }).then(res => {
        if (res.code == "OK") {
          if (res.data && res.data.list) {
            this.videoList = res.data.list;
            this.totalRecord1 = res.data.totalRecord;
          }
          this.isShow7 = true;
        }
      });
    },
    gotoManage() {
      this.$router.push("/manageCenter?step=1");
    },
    getCity() {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=0`)
        .then(res => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },
    gotoScroll(i) {
      this.type = i + 1;
      document.getElementById("view" + this.type).scrollIntoView(true);
    },
    hoverBg(i) {
      if (i == 1) {
        this.hoverBox1 = true;
      }
      if (i == 2) {
        this.hoverBox2 = true;
      }
    },
    leaveBg(i) {
      if (i == 1) {
        this.hoverBox1 = false;
      }
      if (i == 2) {
        this.hoverBox2 = false;
      }
    }
  }
};
</script>
<style>
.MyResumeBox .el-input__inner {
  border-radius: 0;
  border: 1px solid #ccc;
}
.MyResumeBox .el-input__inner:focus {
  border-color: #2026cc;
}
.MyResumeBox .el-textarea__inner:focus {
  border-color: #2026cc;
}
.MyResumeBox .el-select .el-input.is-focus .el-input__inner {
  border-color: #2026cc;
}
.MyResumeBox .el-textarea__inner {
  height: 108px;
  border: 1px solid #e5e5e5;
  border-radius: 0;
}
.MyResumeBox .el-input.is-disabled .el-input__inner {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ccc;
}
.peopleChange {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
}
.peopleChange i {
  color: #2026cc;
  cursor: pointer;
}
.time-picker .el-input__inner::-webkit-input-placeholder {
  color: #606266;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.body {
  background: #FAFAFA;
}
.container{
  width: 1110px;
  padding: 40px 0 120px 0;
  background: #FAFAFA;
  position: relative;
  margin: 0 auto;
  .MyResume{

    .lableName{
        width: 160px;
        height: 337px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        box-sizing: border-box;
        position: fixed;
        top: 106px;
        .title{
            height: 55px;
            line-height: 55px;
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            padding-left: 20px;
        }
        .li{
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            cursor: pointer;
            span{
                padding: 0 8px;
                display: inline-block;
                height: 18px;
                line-height: 18px;
                background: #FE5630;
                border-radius: 2px;
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                margin-left: 10px;
          }
        }
        .active{
            background: #F5F5F5;
        }
    }
    .MyResumeBox{
        width: 635px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-left: 190px;
        padding-bottom: 40px;
        .topTitle{
            width: 100%;
            height: 52px;
            line-height: 52px;
            background: #FFFFFF;
            border: 1px solid #E0E0E0;
            box-sizing: border-box;
            padding: 0 15px 0 20px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            position: relative;
            z-index: 10;
            i{
              width: 52px;
              height: 18px;
              background: #FE5630;
              border-radius: 2px;
              text-align: center;
              line-height: 18px;
              display: inline-block;
              vertical-align: middle;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              margin-left: 12px;
            }
            span{
                float: right;
                font-size: 14px;
                font-weight: 400;
                color: #2026CC;
                cursor: pointer;
            }
        }
        #view1{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 9;
            .infoBox{
                height: 122px;
                padding: 15px 30px;
                box-sizing: border-box;
                position: relative;
                .infoLeft{
                    float: left;
                    .name{
                        height: 36px;
                        font-size: 24px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 36px;
                        span{
                          padding: 0 8px;
                          display: inline-block;
                          height: 18px;
                          line-height: 18px;
                          background: #FE5630;
                          border-radius: 2px;
                          font-size: 12px;
                          font-weight: 400;
                          color: #FFFFFF;
                          margin-left: 10px;
                          vertical-align: middle;
                        }
                    }
                    .year{
                        height: 18px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 18px;
                        margin: 10px 0;
                    }
                    .numberBox{
                        height: 18px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 18px;
                        .phone{
                            margin-right: 20px;
                                img{
                                    width: 12px;
                                    height: 16px;
                                    margin-right: 5px;
                                    vertical-align: text-bottom;
                                }
                        }
                        .email{
                            margin-right: 20px;
                                img{
                                    width: 14px;
                                    height: 12px;
                                    margin-right: 5px;
                                    vertical-align: text-bottom;
                                }
                        }
                        .wechat{
                                img{
                                    width: 16px;
                                    height: 14px;
                                    margin-right: 5px;
                                    vertical-align: text-bottom;
                                }
                        }                        
                    }
                }
                .infoRight{
                    float: right;
                    .imgBox{
                        position: relative;
                        width: 50px;
                        height: 50px;
                        .acartImg{
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                        }
                        .genderImg{
                            position: absolute;
                            width: 18px;
                            height: 18px;
                            bottom: 0;
                            right: 0;
                        }
                    }
                }
                .edit{
                    margin-top: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #2026CC;
                    height: 24px;
                    line-height: 24px;
                    cursor: pointer;
                    position: absolute;
                    right: 30px;
                    bottom: 12px;
                    img{
                        width: 24px;
                        height: 24px;
                        margin-right: 5px;
                    }
                }
            }
            .infoBoxHover{
                box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.2);
            }
            .editInfo{
                width: 605px;
                background: #F8F9FB;
                margin: 20px auto 0;
                padding: 20px 15px;
                box-sizing: border-box;
                .changeImgBox{
                    margin: 20px auto 0;
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    position: relative;
                    img{
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                    } 
                    i{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        background: rgba(51,51,51,0.5);
                        font-size: 12px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 80px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
        }
        #view2{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 8;
            .box{
                padding-top: 40px;
                .advantage{
                    padding: 0 20px;
                    .nameTitle{
                        height: 24px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 24px;
                        padding: 0 10px;
                        margin-bottom: 20px;
                        span{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #2026CC;
                            height: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .textHtml{
                        padding: 10px;
                        p{
                            font-size: 14px;
                            font-weight: 400;
                            color: #666;
                            line-height: 24px;
                        }
                    }
                    .textHtmlHover{
                        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
                    }
                }
                .editAdvantage{
                    width: 605px;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    background: #F8F9FB;
                    margin: 0 auto;
                }
            }
        }
        #view3{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 7;
            .box{
                padding-top: 40px;
                .expect{
                    padding: 0 20px;
                    .nameTitle{
                        height: 24px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 24px;
                        padding: 0 10px;
                        margin-bottom: 20px;
                        span{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #2026CC;
                            height: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .expectList{
                        line-height: 38px;
                        padding: 0 10px;
                        margin-bottom: 5px;
                        cursor: pointer;
                        .expectLeft{
                            float: left;
                            span{
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                                img{
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 6px;
                                }
                            }
                            i{
                                margin: 0 10px;
                            }
                        }
                        .expectRight{
                            float: right;
                            cursor: pointer;
                            span{
                                margin-left: 20px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #2026CC;
                                img{
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                    .expectHover{
                        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.2);
                    }
                }
                .editExpect{
                    width: 605px;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    background: #F8F9FB;
                    margin: 0 auto;
                }
            }
        }
        #view4,#view5{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 6;
            .box{
                padding-top: 40px;
                .experience{
                    padding: 0 20px;
                    .nameTitle{
                        height: 24px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 24px;
                        padding: 0 10px;
                        margin-bottom: 20px;
                        span{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #2026CC;
                            height: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .experienceList{
                        padding: 0 10px 10px;
                        cursor: pointer;
                        margin-bottom: 20px;
                        .experienceName{
                            position: relative;
                            .timeBox{
                                padding-top: 15px;
                                font-size: 15px;
                                font-weight: 600;
                                color: #333333;
                                line-height: 22px;
                                span{
                                    font-size: 15px;
                                    font-weight: 400;
                                    color: #999999;
                                    margin-left: 40px;
                                    vertical-align: top;
                                }
                                p{
                                  float: left;
                                  width: 45%;
                                  max-height: 44px;
                                  line-height: 22px;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;
                                  word-break: break-word;
                                }
                            }
                            .editPosition{
                                position: absolute;
                                right: 0px;
                                top: 15px;
                                cursor: pointer;
                                span{
                                    margin-left: 20px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #2026CC;
                                    img{
                                        width: 24px;
                                        height: 24px;
                                        margin-right: 5px;
                                    }
                                }
                            }
                            .typeNameBox{
                                margin: 10px 0;
                                font-size: 15px;
                                font-weight: 600;
                                color: #333333;
                                line-height: 18px;
                            }
                            .experienceHtml{
                                font-size: 14px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 24px;
                            }
                            .link{
                                margin-top: 10px;
                                height: 17px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 17px;
                                a{
                                    color: #2026CC;
                                }
                            }
                        }
                    }
                    .experienceListHover{
                        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.2);
                    }
                }
                .editExperience{
                    width: 605px;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    background: #F8F9FB;
                    margin: 0 auto;
                    .link{
                        margin-bottom: 20px;
                        .linkTitle{
                            height: 22px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            line-height: 22px;
                            margin-bottom: 10px;
                            i{
                                color: #FE5630;
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
        }
        #view5{
            z-index: 5;
        }
        #view6{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 4;
            .box{
                padding-top: 40px;
                .education{
                    padding: 0 20px;
                    .nameTitle{
                        height: 24px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 24px;
                        padding: 0 10px;
                        margin-bottom: 20px;
                        span{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #2026CC;
                            height: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .educationList{
                        padding: 10px;
                        cursor: pointer;
                        margin-bottom: 20px;
                        .educationLeft{
                            float: left;
                            width: 70%;
                            .schoolName{
                                font-size: 15px;
                                font-weight: 600;
                                color: #333333;
                                line-height: 22px;
                                margin-bottom: 10px;
                                span{
                                    font-size: 15px;
                                    font-weight: 400;
                                    color: #999999;
                                    margin-left: 40px;
                                }
                                span.name{
                                  float: left;
                                  width: 45%;
                                  max-height: 44px;
                                  line-height: 22px;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;
                                  word-break: break-word;
                                  margin-left: 0;
                                  font-weight: 600;
                                  color: #333333;
                                }
                            }
                            .tags{
                                height: 18px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                                line-height: 18px;
                            }
                        }
                        .educationRight{
                            float: right;
                            cursor: pointer;
                            margin-top: 13px;
                            span{
                                margin-left: 20px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #2026CC;
                                img{
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                    .educationHover{
                        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
                    }
                }
                .editEducation{
                    width: 605px;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    background: #F8F9FB;
                    margin: 0 auto;
                }
            }
        }
        #view7{
            padding-top: 106px;
            margin-top: -106px;
            position: relative;
            z-index: 3;
            .box{
                padding-top: 40px;
                .video{
                    padding: 0 20px;
                    .nameTitle{
                        height: 24px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 24px;
                        padding: 0 10px;
                        margin-bottom: 20px;
                        span{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #2026CC;
                            height: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .videoList{
                        padding: 0 10px;
                        .videoLi{
                            float: left;
                            width: 277px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                            cursor: pointer;
                            &:nth-child(2n) {
                                margin-right: 0;
                            }
                            img{
                                width: 277px;
                                height: 160px;
                            }
                            .videoTitle{
                                height: 40px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #0A0A0A;
                                line-height: 20px;
                                margin: 10px 0;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                word-break: break-word;
                            }
                            .tags{
                                height: 18px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #999999;
                                line-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                span{
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .improvedBox{
            padding: 0 30px;
            .improved{
                height: 24px;
                font-size: 16px;
                font-weight: 600;
                color: #333333;
                line-height: 24px;
                margin-bottom: 17px;
                span{
                    padding: 0 8px;
                    display: inline-block;
                    height: 18px;
                    line-height: 18px;
                    background: #FE5630;
                    border-radius: 2px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-left: 10px;
                }
            }
            .addText{
                width: 100%;
                height: 58px;
                line-height: 58px;
                text-align: center;
                background: #F8F9FB;
                font-size: 12px;
                font-weight: 400;
                color: #2026CC;
                cursor: pointer;
                span{
                    color: #999;
                    margin-right: 10px;
                }
            }
        }
        .formBox{
                    margin-top: 20px;
                    height: 72px;
                    .leftForm{
                        float: left;
                        width: 258px;
                        .infoName{
                            height: 22px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #333;
                            line-height: 22px;
                            margin-bottom: 10px;
                            i{
                                color: #FE5630;
                                margin-right: 5px;
                            }
                        }
                    }
                    .leftForm1{
                        width: 274px;
                    }
                    .rightForm{
                        float: right;
                        width: 258px;
                        .infoName{
                            height: 22px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #333;
                            line-height: 22px;
                            margin-bottom: 10px;
                            i{
                                color: #FE5630;
                                margin-right: 5px;
                            }
                        }
                    }
                    .rightForm1{
                        width: 274px;
                    }
                    .radioBox{
                        span{
                            float: left;
                            width: 119px;
                            height: 38px;
                            text-align: center;
                            line-height: 38px;
                            background: #FFFFFF;
                            border: 1px solid #CCCCCC;
                            box-sizing: border-box;
                            margin-right: 20px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #666;
                            cursor: pointer;
                            &:last-child{
                                margin-right: 0;
                            }
                        }
                        span.active{
                            background: rgba(32,38,204,0.05);
                            border: 1px solid #2026CC;
                            color: #2026CC;
                        }
                    }
        }
        .infoTitle{
            height: 24px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            line-height: 24px;
            margin-bottom: 20px;
            span{
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              margin-left: 8px;
            }
        }
        .textareaBox{
            margin-top: 20px;
                .infoName{
                    height: 22px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #333;
                    line-height: 22px;
                    margin-bottom: 10px;
                        i{
                            color: #FE5630;
                            margin-right: 5px;
                        }
                    }
        }
        .butBox1{
            margin-top: 20px;
            span{
                display: inline-block;
                text-align: center;
                cursor: pointer;
                vertical-align: middle;
            }
            span.save{
                width: 86px;
                height: 30px;
                line-height: 30px;
                background: #2026CC;
                font-size: 14px;
                font-weight: 600;
                color: #FFFFFF;
                margin-right: 20px;
            }
            span.close2{
                width: 86px;
                height: 30px;
                border: 1px solid #DADADA;
                font-size: 14px;
                font-weight: 600;
                color: #666666;
                line-height: 30px;
                box-sizing: border-box;
                }
            }
    }
    .fileBox{
        width: 255px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        box-sizing: border-box;
        position: fixed;
        top: 106px;
        padding: 15px 15px 20px;
        .fileName{
            height: 22px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-bottom: 20px;
        }
        .uploadFile1{
            width: 225px;
            height: 34px;
            background: #2026CC;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFE;
            line-height: 34px;
            cursor: pointer;
        }
        .uploadFile2{
            margin-top: 16px;
            width: 225px;
            height: 34px;
            border: 1px solid #2026CC;
            box-sizing: border-box;
            line-height: 34px;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #2026CC;
            cursor: pointer;
        }
        .changeUpload{
          margin-top: 16px;
            &:last-child{
                margin-bottom: 0;
            }
            img{
                float: left;
                width: 30px;
                height: 40px;
                margin-right: 10px;
            }
            .rightBox{
                float: left;
                width: 183px;
                .wordName{
                    height: 17px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 17px;
                    width: 183px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 5px;
                }
                .butBox{
                    height: 18px;
                    font-size: 11px;
                    font-weight: 400;
                    color: #2026CC;
                    line-height: 18px;
                    span{
                        margin-right: 20px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
  } 
  .popBox {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 11111;
    .box {
      width: 540px;
      padding-bottom: 50px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      .title {
        text-align: center;
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 20px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .content {
        text-align: center;
        padding: 0 58px;

        .name {
          height: 28px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-top: 28px;
        }

        .text {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          margin: 20px 0 40px 0;
        }

        .but {
          width: 118px;
          height: 34px;
          line-height: 34px;
          background: #2026CC;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          margin: 0 auto;
          cursor: pointer;
        }

        .img1 {
          width: 120px;
          height: 120px;
          margin-top: 28px;
        }

        .uploadNumber {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin: 20px 0 5px 0;
        }

        .uploadName {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          margin-bottom: 26px;
        }

        .progress {
          width: 175px;
          height: 4px;
          background: #DDDDDD;
          position: relative;
          margin: 0 auto;

          span {
            position: absolute;
            left: 0;
            top: 0;
            height: 4px;
            background: #2026CC;
            width: 5%;
          }
        }

        .fileName {
          margin-top: 28px;
          text-align: left;

          .img2 {
            width: 30px;
            height: 40px;
            vertical-align: bottom;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            display: inline-block;
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          i {
            font-size: 12px;
            font-weight: 400;
            color: #2026CC;
            float: right;
            cursor: pointer;
            line-height: 17px;
            margin-top: 23px;
          }
        }

        .link {
          margin: 20px 0;
          text-align: left;

          .linkTitle {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            margin-bottom: 5px;
          }

          input {
            border-bottom: 1px solid #DDDDDD;
            height: 30px;
            line-height: 30px;
            width: 100%;
          }
        }

        .info {
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          line-height: 17px;
          margin-bottom: 40px;
          text-align: left;
        }
      }

      .content1 {
        padding: 0 88px;
      }
    }
    .box1{
        width: 540px;
        padding-bottom: 30px;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        .title {
            text-align: center;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #e0e0e0;
            font-size: 18px;
            font-weight: 600;
            color: #333;
            position: relative;

            i {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 10px;
            }

            span {
            position: absolute;
            color: #999;
            right: 24px;
            top: 25px;
            width: 13px;
            height: 13px;
            cursor: pointer;
            background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
            background-size: 100% 100%;
            }
        }
        .content{
            padding: 30px 0 40px 0;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
        }
        .but{
            text-align: center;
            span.butClose{
                width: 86px;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                display: inline-block;
                border: 1px solid #DADADA;
                font-size: 14px;
                font-weight: 600;
                color: #666666;
                box-sizing: border-box;
                margin-right: 20px;
                vertical-align: middle;
                
            }
            span.butConfin{
                width: 86px;
                height: 30px;
                background: #2026CC;
                font-size: 14px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 30px;
                cursor: pointer;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
    .box2 {
      width: 760px;
      padding-bottom: 30px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      overflow: hidden;

      .title {
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        i {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          margin-left: 10px;
        }

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 25px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .videoBox {
        padding: 20px 15px 0;
        max-height: 436px;
        overflow-y: scroll;
        margin-bottom: 30px;
        margin-right: -17px;

        .video {
          width: 230px;
          float: left;
          margin-right: 20px;
          margin-bottom: 20px;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .imgBox {
            width: 230px;
            position: relative;

            .img1 {
              width: 230px;
              height: 129px;
            }

            .img2 {
              width: 17px;
              height: 18px;
              position: absolute;
              border-radius: 50%;
              top: 8px;
              right: 8px;
              cursor: pointer;
              z-index: 2;
            }

            span {
              position: absolute;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              left: 8px;
              top: 8px;
              z-index: 2;
            }

            i {
              position: absolute;
              width: 17px;
              height: 17px;
              border: 1px solid #FFFFFF;
              border-radius: 50%;
              top: 8px;
              right: 8px;
              color: #fff;
              cursor: pointer;
              z-index: 2;
            }

            .bg {
              width: 230px;
              height: 129px;
              position: absolute;
              left: 0;
              top: 0;
              background: rgba(0, 0, 0, 0.3);
              z-index: 1;
              cursor: pointer;
            }
          }

          .videoTitle {
            margin-top: 5px;
            height: 34px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-word;
          }
        }

        .noData1 {
          text-align: center;

          p {
            margin: 30px 0 40px 0;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }

          .but {
            width: 117px;
            height: 40px;
            background: #2026CC;
            margin: 0 auto;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }

      .photoBox {
        margin-bottom: 60px;

        .photTitle {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #FF0000;
          line-height: 17px;
          padding-left: 24px;
          margin-bottom: 10px;
        }

        .photoBox1 {
          padding: 0 15px;

          .photo {
            float: left;
            margin-right: 20px;

            &:nth-child(3n) {
              margin-right: 0;
            }

            .imgBox {
              position: relative;
              width: 230px;
              height: 129px;
              margin-bottom: 10px;

              .img1 {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
              }

              .img2 {
                position: absolute;
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                top: 6px;
                right: 7px;
                z-index: 3;
                cursor: pointer;
                width: 18px;
                height: 18px;
              }

              .backG {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 2;
                background: rgba(0, 0, 0, 0.5);
              }
            }

            .photTitle1 {
              width: 230px;
              height: 52px;
            }
          }

          .upImg {
            float: left;
            width: 230px;
            height: 129px;
            border: 1px solid #979797;
            box-sizing: border-box;
            text-align: center;
            background: #F5F5F5;
            cursor: pointer;

            img {
              width: 34px;
              height: 28px;
              margin: 24px 0 10px 0;
            }

            .title1 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
            }

            .title2 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
              margin-top: 10px;
            }

            &:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
      }

      .but {
        text-align: center;
        span.butLeft{
            width: 145px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            border: 1px solid #2026CC;
            font-size: 16px;
            font-weight: 600;
            color: #2026CC;
            margin-right: 20px;
            cursor: pointer;
            display: inline-block;
            box-sizing: border-box;
            vertical-align: middle;
        }
        span.butRight {
          width: 145px;
          height: 44px;
          background: #2026CC;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/MyResume.vue